module.exports = __webpack_public_path__ + "img/fi-rr-star.af21dca6.svg";